export default __webpack_public_path__ + "static/media/banner-ir-background.34cf0df1.jpeg";